import { render, staticRenderFns } from "./RegimeEspecialField.vue?vue&type=template&id=af3757e0&"
import script from "./RegimeEspecialField.vue?vue&type=script&lang=js&"
export * from "./RegimeEspecialField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports